"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationManager = void 0;
const Observable_1 = require("../socket/Observable");
const DomainEvents_1 = require("../utils/DomainEvents");
const models_1 = require("../models");
const mappers_1 = require("../mappers");
const Notification_1 = require("./Notification");
class NotificationManager {
    constructor(organizationUser) {
        this.organizationUser = organizationUser;
    }
    handleMessageNotifications(message, chatLog, notifyUser) {
        const messageType = models_1.MESSAGE_TYPE[message.type];
        const chatId = message.to;
        const messageContentType = models_1.MESSAGE_CONTENT_TYPE[message.contentType];
        const groupType = (0, mappers_1.getGroupTypeFromChatLog)(chatLog);
        const isInactiveChat = chatLog.status !== models_1.CHAT_STATUS.ACTIVE;
        if (isInactiveChat ||
            this.organizationUser.onDND() ||
            this.organizationUser.sameUser(message.user)) {
            return;
        }
        const notificationSettings = this.organizationUser.groupNotificationSetting(groupType);
        const messageTypeConsideringMentions = messageType === models_1.MESSAGE_TYPE.ACKNOWLEDGE &&
            !this.isLoggedInUserMentioned(message)
            ? models_1.MESSAGE_TYPE.NORMAL
            : messageType;
        if (notificationSettings === models_1.CHAT_NOTIFICATION_SETTING.ALL ||
            (notificationSettings === models_1.CHAT_NOTIFICATION_SETTING.IMPORTANT &&
                [models_1.MESSAGE_TYPE.PRIORITY, models_1.MESSAGE_TYPE.ACKNOWLEDGE].includes(messageTypeConsideringMentions))) {
            const isSystemMessages = messageContentType === models_1.MESSAGE_CONTENT_TYPE.SMART ||
                message.type === models_1.MESSAGE_TYPE.INFO;
            notifyUser(new Notification_1.Notification(messageTypeConsideringMentions, isSystemMessages ? chatId : message._id, chatLog.from));
        }
    }
    isLoggedInUserMentioned(message) {
        return (message.mentionedUsers &&
            message.mentionedUsers.find(userId => this.organizationUser.sameUser(userId)));
    }
    handleAlertNotifications(alertResponse, notifyUser) {
        var _a;
        if (!alertResponse.groupInfo) {
            return;
        }
        const alertType = models_1.ALERT_TYPE[alertResponse.type];
        const groupType = models_1.GROUP_TYPE[(_a = alertResponse.groupInfo) === null || _a === void 0 ? void 0 : _a.type];
        if (this.organizationUser.onDND() ||
            (alertResponse.message &&
                this.organizationUser.sameUser(alertResponse.message.user))) {
            return;
        }
        const notificationSettings = this.organizationUser.groupNotificationSetting(groupType);
        if (notificationSettings === models_1.CHAT_NOTIFICATION_SETTING.ALL ||
            (notificationSettings === models_1.CHAT_NOTIFICATION_SETTING.IMPORTANT &&
                [models_1.ALERT_TYPE.ACKNOWLEDGE, models_1.ALERT_TYPE.PRIORITY].includes(alertType))) {
            notifyUser(new Notification_1.Notification(models_1.MESSAGE_TYPE.ACKNOWLEDGE, alertResponse.message ? alertResponse.message._id : alertResponse._id, alertResponse.from));
        }
    }
    subscribeNotifications(notifyUser) {
        const unsubscribeAlertNotifications = Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.NEW_ALERT, this.organizationUser.getOrganization().organizationId), (alertResponse) => this.handleAlertNotifications(alertResponse, notifyUser));
        const unsubscribeMessageNotifications = Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.RECEIVE_MESSAGE, this.organizationUser.getOrganization().organizationId), ({ message, chatLog, }) => this.handleMessageNotifications(message, chatLog, notifyUser));
        return () => {
            unsubscribeAlertNotifications();
            unsubscribeMessageNotifications();
        };
    }
}
exports.NotificationManager = NotificationManager;
